/* import __COLOCATED_TEMPLATE__ from './smart-suggestions-section.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';

interface Suggestion {
  id: number;
  text: string;
  display_priority: number;
}

interface GenerationJob {
  job_id: number;
  status: string;
  website_url: string;
  created_at: string;
  completed_at: string | null;
  error_message: string | null;
}

interface Args {
  smartSuggestionsEnabled: boolean;
  suggestions: Suggestion[];
  showAllSuggestions: boolean;
  isGeneratingSuggestions: boolean;
  isEditingWebsiteUrl: boolean;
  generationJob: GenerationJob | null;
  websiteUrl: string;
  onToggle: () => void;
  onToggleShowAll: () => void;
  onUpdateWebsiteUrl: (event: Event) => void;
  onGenerate: () => void;
  onStartEditingUrl: () => void;
  onCancelEditingUrl: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class SmartSuggestionsSection extends Component<Signature> {
  get displayedSuggestions(): Suggestion[] {
    if (this.args.showAllSuggestions) {
      return this.args.suggestions;
    }
    return this.args.suggestions.slice(0, 3);
  }

  get hasAnySuggestions(): boolean {
    return this.args.suggestions.length > 0;
  }

  get hasMoreThanThree(): boolean {
    return this.args.suggestions.length > 3;
  }

  get hasCompletedUrl(): boolean {
    let job = this.args.generationJob;
    return Boolean(
      job && (job.status === 'completed' || job.status === 'failed') && job.website_url,
    );
  }

  get showUrlDisplay(): boolean {
    return (
      this.hasCompletedUrl && !this.args.isEditingWebsiteUrl && !this.args.isGeneratingSuggestions
    );
  }

  get showUrlInput(): boolean {
    if (this.args.isGeneratingSuggestions) {
      return false;
    }
    return !this.hasCompletedUrl || this.args.isEditingWebsiteUrl;
  }

  get showCancelButton(): boolean {
    return this.args.isEditingWebsiteUrl && this.hasCompletedUrl;
  }

  get displayUrl(): string {
    return this.args.websiteUrl.replace(/^https?:\/\//, '').replace(/\/+$/, '');
  }

  get isGenerateDisabled(): boolean {
    return !this.args.websiteUrl.trim() || this.args.isGeneratingSuggestions;
  }

  isLastTopItem = (index: number): boolean => {
    return index === 2 && this.hasMoreThanThree;
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Sales::SmartSuggestionsSection': typeof SmartSuggestionsSection;
  }
}
